import StartSliderContainer from "./StartSliderContainer";

export default StartSliderContainer;